<clr-modal [clrModalSize]="'xl'" [clrModalOpen]="isModalOpen()" (clrModalOpenChange)="isModalOpen.set($event)">
  <h3 class="modal-title">{{ 'Auftrag erstellen' | mrTranslate }}</h3>
  <div class="modal-body">
    <form clrForm [formGroup]="multiauftrag">
      @if (multiauftrag.errors?.['start-after-and']) {
        <div class="clr-row nxm clr-col-12 clr-col-sm-10 clr-col-md-8 clr-col-lg-6 clr-break-row">
          <clr-alert class="w-100-p" clrAlertType="danger" [clrAlertClosable]="false">
            <clr-alert-item>
              <span class="alert-text">
                {{ 'Das Startdatum muss früher als das Enddatum sein' | mrTranslate }}
              </span>
            </clr-alert-item>
          </clr-alert>
        </div>
      }
      <clr-date-container>
        <label class="clr-required-mark">{{ 'Startdatum' | mrTranslate }}</label>
        <input
          type="date"
          clrDate
          required
          [ngModel]="multiauftrag.controls.startdate.value | localeDate"
          (ngModelChange)="multiauftrag.controls.startdate.setValue(localeDate.tosql($event))"
          [ngModelOptions]="{ standalone: true, updateOn: 'blur' }" />
        <clr-control-error *clrIfError="'required'">
          {{ 'Das Datum muss eingegeben werden' | mrTranslate }}
        </clr-control-error>
      </clr-date-container>
      <clr-date-container>
        <label class="clr-required-mark">{{ 'Enddatum' | mrTranslate }}</label>
        <input
          type="date"
          clrDate
          required
          [ngModel]="multiauftrag.controls.enddate.value | localeDate"
          (ngModelChange)="multiauftrag.controls.enddate.setValue(localeDate.tosql($event))"
          [ngModelOptions]="{ standalone: true, updateOn: 'blur' }" />
        <clr-control-error *clrIfError="'required'">
          {{ 'Das Datum muss eingegeben werden' | mrTranslate }}
        </clr-control-error>
      </clr-date-container>
      <clr-select-container clrInline>
        <label class="clr-required-mark">{{ 'Auftragnehmer' | mrTranslate }}</label>
        <select clrSelect formControlName="auftragnehmer">
          <option [ngValue]="-1" disabled>{{ 'Auftragnehmer auswählen' | mrTranslate }}</option>
          @for (firm of firmen(); track firm.ID) {
            <option [ngValue]="+firm.ID">{{ firm.mFirma }}</option>
          }
        </select>
        <clr-control-error *clrIfError="'required'">
          {{ 'Das Feld muss ausgefüllt werden' | mrTranslate }}
        </clr-control-error>
      </clr-select-container>
      <clr-select-container>
        <label class="clr-required-mark">{{ 'Auftragsgruppe' | mrTranslate }}</label>
        <select clrSelect formControlName="auftragsgruppe">
          <option [ngValue]="null" disabled>{{ 'Auftragsgruppe auswählen' | mrTranslate }}</option>
          @for (group of gruppen(); track group.id) {
            <option [ngValue]="+group.id">{{ group.Bezeichnung }}</option>
          }
        </select>
        <clr-control-error *clrIfError="'required'">
          {{ 'Das Feld muss ausgefüllt werden' | mrTranslate }}
        </clr-control-error>
      </clr-select-container>
      <clr-datalist-container>
        <label>{{ 'Auftragsart' | mrTranslate }}</label>
        <input clrDatalistInput autocomplete="off" type="search" formControlName="auftragsart" style="width: 195px;" />
        <datalist>
           @for (item of auftragsart(); track item) {
          <option [value]="item">{{ item }}</option>
          }

        </datalist>
        <clr-control-error *clrIfError="'required'">
          {{ 'Das Feld muss ausgefüllt werden' | mrTranslate }}
        </clr-control-error>
      </clr-datalist-container>
      <clr-input-container clrInline>
        <label>{{ 'Auftragsnummer' | mrTranslate }}</label>
        <input clrInput formControlName="auftragsnr" />
      </clr-input-container>
      <clr-textarea-container>
        <label>{{ 'Bemerkung' | mrTranslate }}</label>
        <textarea clrTextarea formControlName="bemerkung"></textarea>
      </clr-textarea-container>

      <div style="margin-top: 16px">
        <clr-accordion class="nopadding">
          <clr-accordion-panel>
            <clr-accordion-title>
              {{ 'Mängel' | mrTranslate }}
            </clr-accordion-title>
            <clr-accordion-content *clrIfExpanded>
              <table class="table table-compact margin-0-t">
                <thead>
                  <tr>
                    <th class="left">{{ 'Ort' | mrTranslate }}</th>
                    <th class="left">{{ 'Bezirk' | mrTranslate }}</th>
                    <th class="left">{{ 'Stellwerk' | mrTranslate }}</th>
                    <th class="left">{{ 'Prüfdatum' | mrTranslate }}</th>
                    <th class="left">{{ 'Prüfart' | mrTranslate }}</th>
                    <th class="left">{{ 'Mangel' | mrTranslate }}</th>
                    <th class="left">{{ 'Lage' | mrTranslate }}</th>
                  </tr>
                </thead>
                <tbody>
                  @for (row of selectedValid(); track row.omazsid) {
                    <tr>
                      <td class="left">{{ row.Ort }}</td>
                      <td class="left">{{ row.Bezirk }}</td>
                      <td class="left">{{ row.stellwerk }}</td>
                      <td class="left">{{ row.pruefdatum }}</td>
                      <td class="left">{{ row.pruefart }}</td>
                      <td class="left">{{ row.mangel }}</td>
                      <td class="left">{{ row.lage }}</td>
                    </tr>
                  }
                </tbody>
              </table>
            </clr-accordion-content>
          </clr-accordion-panel>
        </clr-accordion>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button
      [clrLoading]="loadState()"
      type="button"
      class="btn btn-primary margin--12-l"
      [disabled]="trial || multiauftrag.invalid"
      (click)="sendMultiAuftrag()">
      {{ 'Auftrag mit' | mrTranslate }} {{ selectedValid().length }} {{ 'Mängeln anlegen' | mrTranslate }}
    </button>
  </div>
</clr-modal>
